import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_tools/tools/")({
  component: ToolsOverviewPage,
});

function ToolsOverviewPage() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Tools</h1>
      <p className="text-muted-foreground mb-2">
        Welcome to the Tools section. Here you can find utilities and helpers.
      </p>
      <ul className="list-disc pl-6">
        <li>Quick access to app-specific tools</li>
        <li>More features coming soon</li>
      </ul>
    </div>
  );
}
